<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="保险公司">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-model="queryParam.insurerNumber"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-form-item label="车牌号" >
              <a-input v-model="queryParam.car" placeholder="请输入车牌号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="被保人">
              <a-input placeholder="请录入被保险人" v-model="queryParam.insured"/>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :md="4" :sm="6">
              <a-form-item label="业绩状态" >
                <a-select v-model="queryParam.status" placeholder = "请选择" @change="handleStatusChange" allowClear>
                  <a-select-option v-for="item in businessStatusDict" :key="item.value" :value="item.value">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>            
            <a-col :md="4" :sm="6">
              <a-form-item label="投保人">
                <a-input placeholder="请录入投保人" v-model="queryParam.insure"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <a-form-item label="经纪人">
                <j-search-select-tag
                  placeholder="请选择经纪人"
                  v-model="queryParam.createBy"
                  dict="sys_user,realname,username,del_flag=0">
                </j-search-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="10">
              <a-form-item label="项目名称">
                <j-dict-select-tag type="list" v-model="queryParam.project" dictCode="bms_project" placeholder="请选择项目"/>
              </a-form-item>
            </a-col>
            
            <a-col :md="4" :sm="8">
              <a-form-item label="保险起期">
                <j-date placeholder="请选择" v-model="queryParam.insuranceStart"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <a-form-item label="保险迄期">
                <j-date placeholder="请选择" v-model="queryParam.insuranceEnd"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="6">
              <a-form-item label="保单号" >
                <a-input v-model="queryParam.policy" placeholder="请输入保单号"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="6">
              <a-form-item label="险种名称">
                <a-input placeholder="请录入险种名称" v-model="queryParam.insuranceName"/>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
<!--      <a-button type="primary" @click="batchToAudit" style="margin-left: 8px"  v-has="'businessInfoComplete:batchToAudit'">推送开票</a-button>-->
      <a-button type="primary" @click="batchConfirm('4')" v-has="'businessInfoComplete:batchCommit'">批量提交审核</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('业绩补录表')" v-has="'businessInfoComplete:export'">导出</a-button> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>

        <span style="margin-left: 60px" >金额单位：元</span>
        <span style="margin-left: 24px" >保费合计：{{premiumTotal}}</span>
        <span style="margin-left: 24px" >去税保费合计：{{cleanPremiumTotal}}</span>
        <span style="margin-left: 24px" >总佣金合计：{{brokerageTotal}}</span>
      </div>

      <!--, y:theight-->
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>
        <template slot="statusSlot" slot-scope="text, record">
          <span>{{getStatus(record)}}</span>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical"/>

          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
<!--              <a-menu-item v-if="record.status==4" v-has="'businessInfoComplete:confirm'" >
                <a @click="updateStatus(record, 11)" >确认</a>
              </a-menu-item>
              <a-menu-item v-if="record.status==4 || record.status==11" v-has="'businessInfoComplete:sendBack'">
                <a  @click="updateStatus(record, 2)" >退回</a>
              </a-menu-item>-->
              <a-menu-item v-if="record.status==10" v-has="'businessInfoComplete:edit'">
                <a  @click="handleEdit(record)" >补录</a>
              </a-menu-item>
<!--              <a-menu-item v-if="record.status==10" v-has="'businessInfoComplete:toAudit'" >
                <a  @click="toAudit(record)" >提交审核</a>
              </a-menu-item>-->
              <a-menu-item v-if="record.status==12" v-has="'businessInfoComplete:toEnd'" >
                <a @click="updateEnd(record)" >信息批单</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <biz-businessinfo-complete-modal ref="modalForm" @ok="modalFormOk"></biz-businessinfo-complete-modal>
    <!--<a-modal v-model="modalVisible" title="附件" @ok="handleModifyFileOk">
      <j-upload v-model="fileList" :trigger-change="true"  bizPath="achievement"></j-upload>
    </a-modal>-->
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import {getAction, postAction} from '@/api/manage'
  import JDate from '@/components/jeecg/JDate'
  import JUpload from '@/components/jeecg/JUpload'
  import BizBusinessinfoCompleteModal from './modules/BizBusinessinfoCompleteModal'
  import BizBusinessinfoInvoiceForm from './modules/BizBusinessinfoInvoiceForm'
  import { mapGetters } from 'vuex'
  import {BusinessStatusDict_ThirdParty, BusinessInfoStatus} from "../enums/BusinessDict"

  export default {
    name: 'BizBusinessinfoCompleteList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JSearchSelectTag,
      BizBusinessinfoCompleteModal,
      JDate,
      JUpload,
      BizBusinessinfoInvoiceForm,
    },
    data () {
      return {
        description: '业绩补录列表',
        disableMixinCreated: true,
        queryFlag: false, //查询标志，每次点击查询按钮查询成功后设置为true,修改业绩状态字段值后设置为false
        businessStatusDict:[], //状态字典
        invoiceModalVisible: false,
        businessinfoId: '',
        fileList:[],
        brokerageTotal: 0.0, // 合计
        cleanPremiumTotal: 0.0,
        premiumTotal: 0.0,
        isorter:{
          column: 'createTime',
          order: 'desc',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'业绩编号',
            className:'column-text',
            dataIndex: 'businessNumber',
            sorter: true
          },
          {
            title:'业绩状态',
            align:"center",
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title:'业务类型',
            align:"center",
            dataIndex: 'businessType_dictText'
          },
          {
            title:'标的类型',
            align:"center",
            dataIndex: 'productOrLife_dictText'
          },
          /*{
            title:'业绩类型',
            align:"center",
            dataIndex: 'businessPerformanceType_dictText'
          },*/
          {
            title:'项目',
            className:"column-text",
            dataIndex: 'project_dictText'
          },
          {
            title:'经纪人',
            align:"center",
            dataIndex: 'createBy_dictText',
            sorter: true
          },
          {
            title:'部门',
            className:"column-text",
            dataIndex: 'sysOrgCode_dictText',
            sorter: true
          },
          {
            title:'投保人',
            className:"column-text",
            dataIndex: 'insure'
          },
          {
            title:'被保险人',
            className:"column-text",
            dataIndex: 'insured'
          },
          {
            title:'保险人',
            className:"column-text",
            dataIndex: 'insurerNumber_dictText'
          },
          {
            title:'险种类型',
            className:"column-text",
            dataIndex: 'insuranceType_dictText'
          },
          {
            title:'险种名称',
            className:"column-text",
            dataIndex: 'insuranceName'
          },
          {
            title:'车牌号',
            className:'column-text',
            dataIndex: 'car'
          },
          {
            title:'保险起期',
            className:"column-text",
            dataIndex: 'insuranceStart',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'保险讫期',
            className:'column-text',
            dataIndex: 'insuranceEnd',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'保单号',
            className:'column-text',
            dataIndex: 'policy',
            sorter: true
          },
          {
            title:'保额',
            className:'column-money',
            dataIndex: 'insuredAmount',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'费率',
            className:'column-money',
            dataIndex: 'rate',
            customRender:function (text) {
              return !text ? '': text + '‰'
            }
          },
          {
            title:'保费',
            className:'column-money',
            dataIndex: 'premium',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'去税保费',
            className:'column-money',
            dataIndex: 'cleanPremium',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'是否含税',
            align:"center",
            dataIndex: 'includeTax_dictText'
          },
          {
            title:'缴费类型',
            align:"center",
            dataIndex: 'lifeInsurancePayType_dictText'
          },
          {
            title:'佣金比例',
            className:'column-money',
            dataIndex: 'brokerageRatio',
            customRender:function (text) {
              return text == null? '': text + '%'
            }
          },
          {
            title:'总佣金',
            className:'column-money',
            dataIndex: 'brokerageTotal',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'票外金额',
            //align:"center",
            className:'column-money',
            dataIndex: 'outsideInvoiceAmount',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          // V5
          {
            title:'开票编号',
            className:'column-text',
            dataIndex: 'invoiceNumber'
          },
          {
            title:'开票单位', //九安、 九安分公司
            className:'column-text',
            dataIndex: 'invoiceUnit_dictText',
          },
          {
            title:'期数',
            align:"center",
            dataIndex: 'phase'
          },
/*          {
            title:'合作机构',
            className:'column-text',
            dataIndex: 'institution_dictText'
          },*/
          {
            title:'区域',
            className:'column-text',
            dataIndex: 'zone'
          },
          {
            title:'创建日期',
            className:'column-text',
            dataIndex: 'createTime'
          },
          {
            title:'协议附件',
            align:"center",
            dataIndex: 'file',
            scopedSlots: {customRender: 'fileSlot'}
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/bms/bizBusinessinfoComplete/list",
          getMoneyTotal: '/bms/bizBusinessinfoComplete/getMoneyTotal', // 查询合计数
          toAudit: "/bms/bizBusinessinfoComplete/toAudit", // 单条提交审核
          batchConfirm:"/bms/bizBusinessinfoComplete/batchConfirm", // 批量审核/确认/提交审核
          updateStatus:"/bms/bizBusinessinfoComplete/updateStatus", // 确认、退回
          updateFile: '/bms/bizBusinessinfoComplete/updateFile', // 修改附件
          toEnd: "/bms/bizBusinessinfoComplete/toEnd", //单条批单
          getSysOrgCode: "/bms/bizBusinessinfoComplete/getSysOrgCode", //获取当前登陆人部门
        },
      }
    },
    created() {
      this.businessStatusDict = BusinessStatusDict_ThirdParty
    },
    computed:{
/*      canBatchCommit: function(){
        // 当查询参数中业绩状态 不为空 且值为补录中或已退回时可以提交
        return this.queryParam.status && this.queryFlag
            && (this.queryParam.status == BusinessInfoStatus.UNFIX 
              || this.queryParam.status == BusinessInfoStatus.RETURNED)
      },
      canBatchConfirm: function(){
        // 当查询参数中业绩状态 不为空且值为已提交时可以确认或退回
        return this.queryParam.status && this.queryFlag && (this.queryParam.status == BusinessInfoStatus.SUBMIT)
      },*/
    },
    methods: {
      ...mapGetters(["userInfo"]),
      initDictConfig(){
      },
      handleInvoiceInfo(record){
        this.businessinfoId = record.id
        this.invoiceModalVisible = true
      },
      getStatus(record){
        // 业绩状态 10补录中 11已确认 12 已推送 (含已生成发票)
        if(record.status == BusinessInfoStatus.UNFIX){
          return "补录中"
        } else if(record.status == BusinessInfoStatus.SUBMIT){
          return "已提交"
        } else if(record.status == BusinessInfoStatus.READY) {
          return "已确认"
        }else if(record.status == BusinessInfoStatus.PASS){
          return "已推送"
        } else {
          return ""
        }
      },

      // 批量确认
      batchConfirm(status){
        // 未选择，暂不允许将所有符合查询条件的记录都提交审核
        if(this.selectedRowKeys.length <=0){
          this.$message.warning("请先选择业绩")
          return
        }

        //批量确认
        let param = {idList: this.selectedRowKeys, status: status}
        postAction(this.url.batchConfirm, param).then((res) =>{
          if(res.success){
            this.$message.info(res.message)
            this.loadData(1)
          } else {
            this.$message.warn(res.message)
          }
        })
      },

      getQueryParams() {
        if('A03A01'==this.userInfo().orgCode||'A03'==this.userInfo().orgCode) {

        }else {
          if(!this.queryParam.createBy) {
            if(!this.queryParam.insurerNumber){
              this.$message.warning('请选择保险公司')
              return false;
            }
            if(!this.queryParam.insured && !this.queryParam.car){
              this.$message.warning('被保人或车牌号不能为空')
              return false;
            }
          }
        }

        //使用高级查询方式插入默认条件 1. status=10  数据库字段为varchar; 2. source='platform' 
        //{rule:'eq',type:'string',val:10,field:'convert(status,unsigned)'},
        let supQueryObj = [{rule:'eq', type:'string', val:'platform', field: 'source'}]
        let superQueryParams = JSON.stringify(supQueryObj);
        let sqp = {
          superQueryParams: encodeURI(superQueryParams),
          superQueryMatchType: 'and'
        }

        let param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters)
        if(param.insured){
          param.insured = param.insured.trim() // 此处被保人精确匹配，不能查询别人的业绩
        }
        if(param.insure){
          param.insure = `*${param.insure.trim()}*` // 投保人模糊匹配
        }
        if(param.policy){
          param.policy = `*${param.policy.trim()}*` // 保单号模糊匹配
        }
        if(param.insuranceName){
          param.insuranceName = `*${param.insuranceName.trim()}*` // 险种名称模糊匹配
        }
        if(param.car){
          param.car = `*${param.car}*` // 车牌号模糊查询
        }

        //保险起期、迄期
        if(param.insuranceStart){
          param.insuranceStart_begin = param.insuranceStart + ' 00:00:00'
          param.insuranceStart_end = param.insuranceStart + ' 23:59:59'
          delete param.insuranceStart
        }
        if(param.insuranceEnd){
          param.insuranceEnd_begin = param.insuranceEnd + ' 00:00:00'
          param.insuranceEnd_end = param.insuranceEnd + ' 23:59:59'
          delete param.insuranceEnd
        }

        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param);
      },

      loadData(arg) {

        if (arg == 1) {
          this.ipagination.current = 1
          this.onClearSelected();
        }
        let params = this.getQueryParams();
        if(!params){
          return
        }

        this.loading = true
        let url = `${this.url.list}`
        getAction(url, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
            this.queryFlag = true

            if(this.ipagination.current === 1){
              //删除排序条件
              delete params.column
              delete params.order
              //delete params.superQueryParams // status字段类型不对，后台sql重新拼写
              //delete params.superQueryMatchType
              getAction(this.url.getMoneyTotal, params).then((result)=>{
                if (result.success) {
                  this.brokerageTotal = !result.result.brokerageTotal ? '': result.result.brokerageTotal.toLocaleString()
                  this.cleanPremiumTotal = !result.result.cleanPremiumTotal ? '': result.result.cleanPremiumTotal.toLocaleString()
                  this.premiumTotal = !result.result.premiumTotal ? '': result.result.premiumTotal.toLocaleString()
                }
              })
            }
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      //确认、退回
      updateStatus(record, status){
        if(record === undefined || record === null){
          return
        }

        let param = {id: record.id, status: status}
        postAction(this.url.updateStatus, param).then((res) =>{
          if(res.success){
            this.$message.info(res.result)
            this.loadData()
          } else {
            this.$message.warn(res.message)
          }
        })
      },
      //单条更新状态,提交审核
      toAudit(record){
        if(record === undefined || record === null){
          return
        }

        let param = {id: record.id, status: BusinessInfoStatus.SUBMIT}
        postAction(this.url.toAudit, param).then((res) =>{
          if(res.success){
            this.$message.info(res.result)
            this.loadData()
          } else {
            this.$message.warn(res.message)
          }
        })
      },

      //单条信息批单
      updateEnd(record){
        if(record === undefined || record === null){
          return
        }
        
        let param = {id: record.id, status: BusinessInfoStatus.END}
        postAction(this.url.toEnd, param).then((res) =>{
          if(res.success){
            this.$message.info(res.result)
            this.loadData()
          } else {
            this.$message.warn(res.message)
          }
        })
      },

      // 批量提交审核
      batchToAudit(){
        // 未选择，暂不允许将所有符合查询条件的记录都提交审核
        if(this.selectedRowKeys.length <=0){
          this.$message.warning("请先选择业绩")
          return
        }

        let param = {idList: this.selectedRowKeys, status: BusinessInfoStatus.SUBMIT}
        postAction(this.url.batchToAudit, param).then((res) =>{
          if(res.success){
            this.$message.info(res.result)
            this.loadData()
          } else {
            this.$message.warn(res.message)
          }
        })
      },

      // 修改附件
      /*handleModifyFile(record){
        if(record.fileUpdateCount >= 2){
          this.$message.warning("附件已修改两次，不能再修改")
          return
        }
        this.modifyId = record.id
        this.fileList = record.file
        this.modalVisible = true
      },*/
      //确认按钮, 保存当前列表
      /*handleModifyFileOk(event){
        let param = {id: this.modifyId, file: this.fileList}
        postAction(this.url.updateFile, param).then(res =>{
          if(res.success){
            this.modalVisible = false
            this.$message.info("修改成功")
            this.loadData()
          } else {
            this.$message.warning("修改失败")
          }
        })
      },*/

      handleCancel(){
        this.$nextTick(()=> {
          this.invoiceModalVisible = false
        })
      },

      handleOk(){
        this.$nextTick(()=> {
          this.invoiceModalVisible = false
        })
      },

      handleStatusChange(){
        this.queryFlag = false //改变值后点击查询按钮，查询成功才能设置为true
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>